import React, { MutableRefObject } from 'react';
import { useSelector } from 'react-redux';

import { selectStudioMode } from '../../store/modules/studio/selectors';
import PrompterControls from './prompter/PrompterControls';
import CameraControls from './camera/CameraControls';
import { StudioMode } from '../../configs/studio';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
  bottomViewContainerId: string;
};

const StudioControlComponent = ({ refPrompter, bottomViewContainerId }: Props) => {
  const studioMode = useSelector(selectStudioMode);

  switch (studioMode) {
    case StudioMode.CAMERA:
      return (
        <CameraControls
          refPrompter={refPrompter}
          bottomViewContainerId={bottomViewContainerId}
        />
      );
    case StudioMode.TELEPROMPTER:
      return (
        <PrompterControls
          refPrompter={refPrompter}
        />
      );
    default:
      return null;
  }
};

export default StudioControlComponent;
